import { TMVKData } from '../../types/mvk';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EMvkActionTypes {
  SetMvk = 'mvk/setMvk',
  SetMvkLoadingError = 'mvk/setMvkLoadingError',
}

export type TSetMvk = ITypedReduxAction<EMvkActionTypes.SetMvk, TMVKData>;

/**
 * Redux action, который записывает в store данные МВК
 * @param state boolean
 */
export const setMvk: (state: TMVKData) => TSetMvk = actionGenerator<EMvkActionTypes.SetMvk, TMVKData>(
  EMvkActionTypes.SetMvk,
);

export type TSetMvkLoadingError = ITypedReduxAction<EMvkActionTypes.SetMvkLoadingError, boolean>;

/**
 * Redux action, который записывает в store статус ошибки загрузки МВК
 * @param state boolean
 */
export const setMvkLoadingError: (state: boolean) => TSetMvkLoadingError = actionGenerator<
  EMvkActionTypes.SetMvkLoadingError,
  boolean
>(EMvkActionTypes.SetMvkLoadingError);
